const VIDEO_FILE = /\.(mp4|webm|mov)$/i;

const parse = (href) => {
  try {
    const url = new URL(href);
    return url.protocol === 'https:' ? url : null;
  } catch {
    return null;
  }
};

const iframeSrc = (url) => {
  const host = url.hostname.replace(/^www\./, '');
  const parts = url.pathname.split('/').filter(Boolean);

  if (host === 'loom.com' && ['share', 'embed'].includes(parts[0]) && parts[1]) {
    return `https://www.loom.com/embed/${parts[1]}`;
  }
  if (host === 'vimeo.com' && /^\d+$/.test(parts[0] || '')) {
    return `https://player.vimeo.com/video/${parts[0]}${parts[1] ? `?h=${parts[1]}` : ''}`;
  }
  if (host === 'player.vimeo.com' && parts[0] === 'video' && parts[1]) {
    return `https://player.vimeo.com/video/${parts[1]}${url.search}`;
  }
  if (host === 'youtu.be' && parts[0]) {
    return `https://www.youtube-nocookie.com/embed/${parts[0]}`;
  }
  if (host === 'youtube.com' || host === 'm.youtube.com') {
    const id = parts[0] === 'watch' ? url.searchParams.get('v') : ['embed', 'shorts'].includes(parts[0]) && parts[1];
    if (id) return `https://www.youtube-nocookie.com/embed/${id}`;
  }
  return null;
};

export default function videoEmbed(href) {
  const url = parse(href);
  if (!url) return null;

  const src = iframeSrc(url);
  if (src) return { kind: 'iframe', src };
  if (VIDEO_FILE.test(url.pathname)) return { kind: 'file', src: url.href };
  return null;
}
